export enum ConfirmationModalTestEnum {
  BODY = 'confirmation-modal-body',
  FOOTER = 'confirmation-modal-footer',
  CANCEL_BTN = 'confirmation-modal-cancel-btn',
  CONFIRM_BTN = 'confirmation-modal-confirm-btn',
}
